import { render, staticRenderFns } from "./GroupType.vue?vue&type=template&id=9f0075b2&scoped=true&"
import script from "./GroupType.vue?vue&type=script&lang=js&"
export * from "./GroupType.vue?vue&type=script&lang=js&"
import style0 from "./GroupType.vue?vue&type=style&index=0&id=9f0075b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0075b2",
  null
  
)

export default component.exports